<div class="page-contents">
    <div class="subBlockContainer">
      <div class="breadcrumbWrapper">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="child-loader">
        <div class="subBlockContainer toplevel catalogueedit" [ngStyle]="{'width': toplevelWidth}">
          <div class="subBlockContent" id="catalogueedit">
            <child-header [title]="title"  (closeEvent)="close()" [showSubscription]="true" [editMode]="false" (addEvent)="onAddNewsletter()" titleAdd="Add New Newsletter" [showAdd]="true" (subscriptionEvent)="navigateTo('catalogues/subscriptions')" [menuDownloadItems]="['Download All to Excel','Download CSV']" (menuDownloadEvent)="onMenuDownload($event)" ></child-header>
  
              <div class="inner-subBlock-wrapper">
                <div class="page-title-wrapper" style="display: none;">
                  <div class="title blade-title-font">
                    <span id="subscriptionButton" class="basic-icon subscription-icon" placement="bottom"
                      ngbTooltip="Subscription" [routerLink]="['subscriptions']"></span>
                    <ng-template #popContent>
                      <button type="button" class="close" aria-label="Close"
                        (click)="closeDownload()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <div class="popover-inner-wrapper">
                        <span (click)="sendAllNewsletters(accountId, template, $event)">Download All to Excel</span>
                      </div>
                      <a href="{{Catalogue?.dataFeedCSV}}" (click)="downloadCSV()">
                        <div class="popover-inner-wrapper">
                          <span>Download CSV</span>
                        </div>
                      </a>
                    </ng-template>
                    <ng-template #template let-d="dismiss">
                      <div class="modal-body">
                        <div style="height:20px">
                          <button type="button" class="close popClose" aria-label="Close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="align-center">{{newsletterMsg}}</div>
                      </div>
                    </ng-template>
                    <span #popover="ngbPopover" id="editDownloadButton" class="basic-icon download-icon"
                     placement="bottom" [ngbPopover]="popContent"
                      triggers="manual" (click)="openPop()"
                      [ngClass]="{'active-icon' : iconCanbeActive, 'default-icon': !iconCanbeActive }"></span>
                    <span id="newNewsletter" class="basic-icon add-icon"
                      placement="bottom" ngbTooltip="Add New Newsletter"></span>
                  </div>
                </div>
                <div class="row filter-wrapper" style="padding: 8px 0;">
                  <div class="col-md-3">
                    <div class="searchInputGroup">
                      <div class="searchIcon">
                        <img src="../images/new_ui/filter.png">
                      </div>
                      <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                        onblur="this.placeholder='Filter'" [(ngModel)]="catalogueFilterValue" (ngModelChange)="onChange()"
                        #filterInput>
                    </div>
                  </div>
                  <!-- # brand filter -->
                  <div class="listpart col-md-3 select-outer-wrapper">
                    <mat-form-field (click)="tickAllOptionsByOpeningPanel($event)">
                      <mat-select #matSelect placeholder="Brand" multiple [(ngModel)]="selectedBrands"
                        #brandSelect="ngModel" (selectionChange)="updateBrandList(brandSelect)" (ngModelChange)="onChange()"
                        (openedChange)="openedChange($event)">
                        <!-- Select with custom trigger text -->
                        <mat-select-trigger>
                          <span *ngIf="selectedBrands[0] === 'all'">
                            {{selectedBrands ? selectedBrands[1] : ''}}
                            <span *ngIf="selectedBrands?.length > 1" class="example-additional-selection">
                              (+{{selectedBrands.length - 2}} others)
                            </span>
                          </span>
    
                          <span *ngIf="selectedBrands[0] !== 'all'">
                            {{selectedBrands ? selectedBrands[0] : ''}}
                            <span *ngIf="selectedBrands?.length > 1" class="example-additional-selection">
                              (+{{selectedBrands.length - 1}} others)
                            </span>
                          </span>
                        </mat-select-trigger>
                        <mat-option #allSelected (click)="toggleAllSelection(brandSelect)" value="all">Select all
                        </mat-option>
                        <mat-option *ngFor="let item of fixedUniqueBrands | sortByAlphabeticPipe" [value]="item">
                          {{item}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 align-right ">
                    <span class="clearFilterButton primary-red-button font-color-p1" (click)="filterReset()"
                      *ngIf="hasFilterChanged || selectedBrands?.length">
                      Clear filter</span>
                    <span class="primary-red-button" (click)="switchCatalogueMode()"
                      *ngIf="currentUserModel?.isStaffAccount">
                      Switch to view mode</span>
                  </div>
                </div>
                <ng-container *ngIf="hasEmptyResult">
                  <div class="noResult-wrapper">
                    <div class="top-divider"></div>
                    <div><img src="../images/new_ui/no-found.png"></div>
                    <div>No results found</div>
                    <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
                    <button class="button button-red button-large" (click)="filterReset()">Try again</button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!hasEmptyResult">

                  <div class="shared-outer-wrapper table-header-allign">
                    <table matSort (matSortChange)="sortData($event)" class="white">
                      <thead>
                        <tr class="row">
                          <th class="col-lg-1 col-md-1"></th>
                          <th class="col-lg-1 col-md-1" mat-sort-header="brand">BRAND</th>
                          <th class="col-lg-2 col-md-2 ">Title</th>
                          <th *ngIf="!isDev" class="col-lg-4 col-md-4">DESCRIPTION</th>
                          <th *ngIf="isDev" class="col-lg-3 col-md-3">DESCRIPTION</th>
                          <th class="col-lg-2 col-md-2" mat-sort-header="dateModified">DATE MODIFIED</th>
                          <th class="col-lg-2 col-md-2"></th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="shared-outer-wrapper child-body">
                    <table matSort (matSortChange)="sortData($event)" class="white">
                      <thead hidden="true">
                        <tr class="row">
                          <th class="col-lg-1 col-md-1"></th>
                          <th class="col-lg-1 col-md-1" mat-sort-header="brand">BRAND</th>
                          <th class="col-lg-2 col-md-2 ">Title</th>
                          <th *ngIf="!isDev" class="col-lg-4 col-md-4">DESCRIPTION</th>
                          <th *ngIf="isDev" class="col-lg-3 col-md-3">DESCRIPTION</th>
                          <th class="col-lg-2 col-md-2" mat-sort-header="dateModified">DATE MODIFIED</th>
                          <th class="col-lg-2 col-md-2"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container
                          *ngFor="let item of sortedData | singleSelectionPipe : catalogueFilterValue : selectedBrands : allSelected.selected : 'catalogues' ">
                          <tr class="row">
                            <td class="col-lg-1 col-md-1 {{item.id}}">
                              <label class="switch">
                                <input type="checkbox" [checked]="item.published == '0'"
                                  (change)="changeType($event, item)">
                                <span class="slider round"></span>
                              </label>
                            </td>
                            <td class="col-lg-1 col-md-1" [class.unchecked]="item.published == '1'">
                              {{item?.brand}}</td>
                            <td class="col-lg-2 col-md-2" [class.unchecked]="item.published == '1'">
                              {{item?.title}}</td>
                            <td *ngIf="!isDev" class="col-lg-4 col-md-4" [class.unchecked]="item.published == '1'">
                              {{item?.description}}</td>
                            <td *ngIf="isDev" class="col-lg-3 col-md-3" [class.unchecked]="item.published == '1'">
                                {{item?.description}}</td>
                            <td class="col-lg-2 col-md-2" [class.unchecked]="item.published == '1'">
                              <!--{{dateFormat(item)}}</td> -->
                              {{item?.mdate}}</td>
                            <td *ngIf="isDev && !item?.isCompliant" class="col-lg-1 col-md-1 cursor-pointer" (click)="getActiveStockCount(item)">
                                ?
                            </td>
                            <td *ngIf="isDev && item?.isCompliant" class="col-lg-1 col-md-1">
                              {{item?.isCompliant.activeStockCount}}
                            </td>
                            <td class="col-lg-2 col-md-2">
                              <div>
                                <button [routerLink]="['editnewsletter/'+ item?.news_id]"
                                  class="button button-red button-mid">Update</button>
                              </div>
                              <div id="catEditDownloadButton" class="basic-icon download-icon download-button"
                                  (click)="exportExcelForCatalogue(item?.news_id)"></div>
                              <div id="catDeleteButton" class="basic-icon delete-icon delete-button"
                                (click)="deleteNewsletter(item.news_id)" *ngIf="currentUserModel?.isStaffAccount"></div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
              </div>
              <loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)">
              </loading-screen>
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
